import { createAsyncThunk } from '@reduxjs/toolkit';
import axios  from 'config/axios';
import { setErrors,setAlerts, setSingleAlert, setTopAlerts,setThreat, setComplianceStandards, setAvailableStandards} from  '../../../stores/modules/ecs/alertreducer'
export const fetchReviewReports = createAsyncThunk('alert/review', async ({idToken,data}, { dispatch }) => {
    try {
      let response = await axios.put(`${process.env.REACT_APP_CRS_ALERTS_ENDPOINT_URL}/alerts/review`, data,{
      });
      dispatch(setAlerts(response.data));
    } catch (error) {
      dispatch(setErrors(error.response));
    }
  });

  export const deleteAlerts= async (params) => {
    try {
       await axios.delete(`${process.env.REACT_APP_CRS_ALERTS_ENDPOINT_URL}/alerts`,{
        params:params,
      });
      return true;
 
    } catch (error) {
      return error?.response?.data?.message;
    }
  };
  
  export const fetchAlertsByQuery= createAsyncThunk('alert/getAlertByQuery', async ({idToken,params}, { dispatch }) => {
    try {
      const response= await axios.get(`${process.env.REACT_APP_CRS_ALERT_ENDPOINT_URL}/alert`,{
        params:params,
      });
   
      dispatch(setSingleAlert(response.data));
      
    } catch (error) {
      dispatch(setErrors(error.response));
    }
  });

export const fetchTopAlerts = createAsyncThunk('alert/fetchTopAlerts', async ({ idToken, params }, { dispatch }) => {
  try {
    dispatch(setTopAlerts([]));
    setErrors([]);
    let response;
    if (params.compliance){
      delete params.compliance;
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/top-alerts`,  {
        params: params,
      });
    }
    else{
      response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/top-alerts`, {
        params: params,
      });
    }
    if (response.status === 200){
      dispatch(setTopAlerts(response.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const saveAlerts= createAsyncThunk('alert/saveAlerts', async ({idToken,id,data}, { dispatch }) => {
  try {

    const response= await axios.put(`${process.env.REACT_APP_CRS_ALERT_ENDPOINT_URL}/alert/${id}`,data,{
    });
 
    return response?.status;
    
  } catch (error) {
    return error?.response?.data?.message;
  }
});

export const fetchAlertsList = async ({ params, idToken }) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };

    
    if (params.search) {
      updatedParams.search = params.search;
    }
    let response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-list`, {
      params: updatedParams,
    });

    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchAlertById= createAsyncThunk('alert/fetchAlertById', async ({ idToken,id }, { dispatch }) => {
  try {
    
setErrors([]);
    let response = await axios.get(`${process.env.REACT_APP_CRS_ALERT_ENDPOINT_URL}/alert/${id}`, {
    });
    dispatch(setThreat(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchComplianceAlerts = async ({ params, idToken }) => {
  try {
    const updatedParams = { ...params, page: params.page, limit: params.limit };

    
    if (params.search) {
      updatedParams.search = params.search;
    }

    let response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/alerts-list`, {
      params: updatedParams,
    });
    return response;
  } catch (error) {
    return error?.response?.data?.message;
  }
};

export const fetchComplianceStandards= createAsyncThunk('alert/fetchComplianceStandards', async (idToken, { dispatch }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_COMPLIANCE_STANDARD_ENDPOINT_URL}/compliance-standards`, {
    });

    dispatch(setComplianceStandards(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchAvailableStandards= createAsyncThunk('alert/fetchAvailableStandards', async ({idToken,params}, { dispatch }) => {
  try {
    let response = await axios.get(`${process.env.REACT_APP_CRS_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/available-standards`, {
      params:params,
    });

    dispatch(setAvailableStandards(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});